import {
  AnimalProductIntroFormValues,
  AnimalProductPriceFormValues,
} from "Components/Features/CheckPrice/Products/RiskProducts/Animal/animalInterfaces";
import {
  CabinContentsProductDetailsFormValues,
  CabinContentsProductIntroFormValues,
  CabinContentsProductPriceFormValues,
} from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/CabinContents/cabinContentsInterfaces";
import {
  HousePriceFormValues,
  HouseProductDetailsFormValues,
  HouseProductInfoDetailsFormValues,
  HouseProductIntroFormValues,
} from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/House/houseFormValuesInterfaces";
import {
  HouseContentsProductDetailsFormValues,
  HouseContentsProductIntroFormValues,
  HouseContentsProductPriceFormValues,
} from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/HouseContents/houseContentsFormValuesInterfaces";
import {
  RentalProductIntroFormValues,
  RentalProductPriceFormValues,
} from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/Rental/rentalFormValuesInterfaces";
import {
  MopedProductDetailsFormValues,
  MopedProductIntroFormValues,
  MopedProductPriceFormValues,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Moped/mopedInterface";
import {
  MotorcycleProductDetailsFormValues,
  MotorcycleProductIntroFormValues,
  MotorcycleProductPriceFormValues,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Motorcycle/motorcycleInterface";
import {
  TractorProductDetailsFormValues,
  TractorProductIntroFormValues,
  TractorProductPriceFormValues,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Tractor/tractorInterface";
import {
  TrailerProductDetailsFormValues,
  TrailerProductIntroFormValues,
  TrailerProductPriceFormValues,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Trailer/trailerInterface";
import {
  VeteranAutoProductDetailsFormValues,
  VeteranAutoProductIntroFormValues,
  VeteranAutoProductPriceFormValues,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/VeteranAuto/veteranAutoInterface";
import {
  HuseierneHouseContentsProductIntroFormValues,
  HuseierneHouseContentsProductPriceFormValues,
} from "Features/CheckPrice/Products/RiskProducts/HouseProducts/HuseierneHouseContents/huseierneHouseContentsFormValuesInterfaces";
import { EntityTypeOld, INSURANCE_NAME_VALUE } from "Store/interfaces/products";

import { AdviceProductDetailsFormValues } from "Components/Features/CheckPrice/Products/Advice/ProductDetails/FormElements/interfaces";
import { AdviceProductIntroFormValues } from "Components/Features/CheckPrice/Products/Advice/ProductIntro/interfaces";
import { AdvicePriceFormValues } from "Components/Features/CheckPrice/Products/Advice/ProductPrice/AdviceCards/interfaces";
import { AkaAdvicePriceFormValues } from "Components/Features/CheckPrice/Products/Advice/ProductPriceAka/AkaAdviceCards/interfaces";
import { AkaStudentProductIntroFormValues } from "Components/Features/CheckPrice/Products/AkaProducts/AkaStudent/ProductIntro/akaStudentProductIntroInterfaces";
import { AkaStudentProductPriceFormValues } from "Components/Features/CheckPrice/Products/AkaProducts/AkaStudent/ProductPrice/akaStudentProductPriceInterfaces";
import { AkaChildProductIntroFormValues } from "Components/Features/CheckPrice/Products/LifeProducts/AkaChild/ProductIntro/akaChildProductIntroInterfaces";
import { AkaHealthProductDetailsFormValues } from "Components/Features/CheckPrice/Products/LifeProducts/AkaHealth/ProductDetails/akaHealthProductDetailsInterfaces";
import { AkaHealthProductIntroFormValues } from "Components/Features/CheckPrice/Products/LifeProducts/AkaHealth/ProductIntro/akaHealthProductIntroInterfaces";
import { AkaHealthProductPriceFormValues } from "Components/Features/CheckPrice/Products/LifeProducts/AkaHealth/ProductPrice/akaHealthProductPriceInterfaces";
import { ChildProductDetailsFormValues } from "Components/Features/CheckPrice/Products/LifeProducts/Child/ProductDetails/childProductDetailsInterfaces";
import { ChildProductIntroFormValues } from "Components/Features/CheckPrice/Products/LifeProducts/Child/ProductIntro/childProductIntroInterfaces";
import { ChildHealthPriceFormValues } from "Components/Features/CheckPrice/Products/LifeProducts/Child/ProductPrice/ChildHealth/childHealthPriceInterfaces";
import { ChildPriceFormValues } from "Components/Features/CheckPrice/Products/LifeProducts/Child/ProductPrice/childProductPriceInterfaces";
import { HealthProductDetailsFormValues } from "Components/Features/CheckPrice/Products/LifeProducts/Health/ProductDetails/healthProductDetailsInterfaces";
import { HealthProductIntroFormValues } from "Components/Features/CheckPrice/Products/LifeProducts/Health/ProductIntro/healthProductIntroInterfaces";
import { HealthProductPriceFormValues } from "Components/Features/CheckPrice/Products/LifeProducts/Health/ProductPrice/healthProductPriceInterfaces";
import { PregnantAndNewbornDetailsFormValues } from "Components/Features/CheckPrice/Products/LifeProducts/PregnantAndNewborn/ProductDetails/pregnantAndNewbornProductDetailsInterfaces";
import { PregnantAndNewbornIntroFormValues } from "Components/Features/CheckPrice/Products/LifeProducts/PregnantAndNewborn/ProductIntro/pregnantAndNewbornProductIntroInterfaces";
import { PregnantAndNewbornPriceFormValues } from "Components/Features/CheckPrice/Products/LifeProducts/PregnantAndNewborn/ProductPrice/pregnantAndNewbornProductPriceInterfaces";
import { SopSicknessLeaveProductIntroFormValues } from "Components/Features/CheckPrice/Products/LifeProducts/SopSicknessLeave/ProductIntro/sopSicknessLeaveProductIntroInterfaces";
import { AccidentProductIntroFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/Accident/ProductIntro/accidentProductIntroFormValues";
import { AccidentProductPriceFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/Accident/ProductPrice/accidentProductPriceFormValues";
import { AkaFamilyAccidentProductIntroFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/AkaFamilyAccident/ProductIntro/akaFamilyAccidentProductIntroInterfaces";
import { AkaFamilyAccidentProductPriceFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/AkaFamilyAccident/ProductPrice/akaFamilyAccidentProductPriceInterfaces";
import { AkaTravelProductIntroFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/AkaTravel";
import { AkaTravelProductPriceFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/AkaTravel/ProductPrice/akaTravelProductPriceInterfaces";
import { CabinProductDetailsFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/Cabin/ProductDetails/cabinProductDetailsInterfaces";
import { CabinProductIntroFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/Cabin/ProductIntro/cabinProductIntroInterfaces";
import { CabinPriceFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/Cabin/ProductPrice/cabinProductPriceInterfaces";
import { TravelProductIntroFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/Travel/ProductIntro/travelProductIntroInterfaces";
import { TravelPriceFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/Travel/ProductPrice/travelProductPriceInterfaces";
import { ValuablesProductFormState } from "Components/Features/CheckPrice/Products/RiskProducts/Valuables";
import { BoatProductDetailsFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Boat/ProductDetails/boatProductDetailsInterfaces";
import { BoatProductIntroFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Boat/ProductIntro/boatProductIntroInterfaces";
import { BoatProductPriceFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Boat/ProductPrice/boatProductPriceInterfaces";
import { CarProductDetailsFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Car/ProductDetails/FormElements/interfaces";
import { CarProductIntroFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Car/ProductIntro/FormElements/interfaces";
import { CarPriceFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Car/ProductPrice/interfaces";
import { CaravanProductDetailsFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Caravan/ProductDetails/interfaces";
import { CaravanProductIntroFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Caravan/ProductIntro/interfaces";
import { CaravanProductPriceFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Caravan/ProductPrice/interfaces";
import { SopSicknessLeaveProductPriceFormValues } from "Features/CheckPrice/Products/LifeProducts/SopSicknessLeave/ProductPrice/sopSicknessLeaveProductPriceFormValues";
import { Cart } from "Store/cart/cartInterfaces";
import { InsuranceProductPriceRequestInfo } from "Store/interfaces/products/checkPrice";
import { InsuranceProduct } from "Store/interfaces/products/checkout";
import { InsuranceCoverage } from "Store/interfaces/products/coverage";

export interface PriceCalculationState {
  priceCalculationFormStates: FormStates;
  priceCalculationRequest: PriceCalculationRequest;
  priceCalculationResults: PriceCalculationResponseEntity;
  priceCalculationResult: PriceCalculationResponseEntity;
  storedProduct: ProductEntity;
  storedAdviceCart: StoredAdviceCartEntity;
}

export type ProductEntity = EntityTypeOld<InsuranceProduct, OperationType>;
export type StoredAdviceCartEntity = EntityTypeOld<Cart, OperationType>;

export type FormStates = Record<string, FormState>;

export type FormState =
  | AkaChildProductIntroFormValues
  | AkaAdvicePriceFormValues
  | AccidentProductIntroFormValues
  | AccidentProductPriceFormValues
  | AdvicePriceFormValues
  | AdviceProductDetailsFormValues
  | AdviceProductIntroFormValues
  | AkaFamilyAccidentProductIntroFormValues
  | AkaFamilyAccidentProductPriceFormValues
  | AkaHealthProductIntroFormValues
  | AkaHealthProductDetailsFormValues
  | AkaTravelProductIntroFormValues
  | AkaStudentProductIntroFormValues
  | AkaStudentProductPriceFormValues
  | BoatProductDetailsFormValues
  | BoatProductIntroFormValues
  | BoatProductPriceFormValues
  | AnimalProductIntroFormValues
  | AnimalProductPriceFormValues
  | CarProductIntroFormValues
  | CarProductDetailsFormValues
  | CarPriceFormValues
  | CaravanProductIntroFormValues
  | CaravanProductDetailsFormValues
  | CaravanProductPriceFormValues
  | CabinProductIntroFormValues
  | CabinProductDetailsFormValues
  | CabinPriceFormValues
  | CabinContentsProductIntroFormValues
  | CabinContentsProductDetailsFormValues
  | CabinContentsProductPriceFormValues
  | ChildPriceFormValues
  | ChildProductDetailsFormValues
  | ChildProductIntroFormValues
  | ChildHealthPriceFormValues
  | HealthProductIntroFormValues
  | HealthProductDetailsFormValues
  | HouseContentsProductDetailsFormValues
  | HouseContentsProductIntroFormValues
  | HouseContentsProductPriceFormValues
  | HousePriceFormValues
  | HouseProductInfoDetailsFormValues
  | HouseProductDetailsFormValues
  | HouseProductIntroFormValues
  | HuseierneHouseContentsProductIntroFormValues
  | MopedProductIntroFormValues
  | MopedProductDetailsFormValues
  | MopedProductPriceFormValues
  | MotorcycleProductIntroFormValues
  | MotorcycleProductDetailsFormValues
  | MotorcycleProductPriceFormValues
  | PregnantAndNewbornDetailsFormValues
  | PregnantAndNewbornIntroFormValues
  | PregnantAndNewbornPriceFormValues
  | RentalProductIntroFormValues
  | RentalProductPriceFormValues
  | SopSicknessLeaveProductIntroFormValues
  | SopSicknessLeaveProductPriceFormValues
  | TractorProductIntroFormValues
  | TractorProductDetailsFormValues
  | TractorProductPriceFormValues
  | TrailerProductIntroFormValues
  | TrailerProductDetailsFormValues
  | TrailerProductPriceFormValues
  | TravelPriceFormValues
  | TravelProductIntroFormValues
  | ValuablesProductFormState
  | VeteranAutoProductIntroFormValues
  | VeteranAutoProductDetailsFormValues
  | VeteranAutoProductPriceFormValues;

export type PriceFormState =
  | AccidentProductPriceFormValues
  | AkaFamilyAccidentProductPriceFormValues
  | AkaHealthProductPriceFormValues
  | AkaTravelProductPriceFormValues
  | AnimalProductPriceFormValues
  | CabinPriceFormValues
  | CabinContentsProductPriceFormValues
  | CaravanProductPriceFormValues
  | CarPriceFormValues
  | ChildPriceFormValues
  | HealthProductPriceFormValues
  | HouseContentsProductPriceFormValues
  | HousePriceFormValues
  | MopedProductPriceFormValues
  | MotorcycleProductPriceFormValues
  | HuseierneHouseContentsProductPriceFormValues
  | PregnantAndNewbornPriceFormValues
  | SopSicknessLeaveProductPriceFormValues
  | TractorProductPriceFormValues
  | TrailerProductPriceFormValues
  | TravelPriceFormValues
  | VeteranAutoProductPriceFormValues;

export interface FormStateUpdate {
  productName?: INSURANCE_NAME_VALUE;
  stepId: string;
  formState: FormState;
}

export type PriceCalculationResponseEntity = EntityTypeOld<
  PriceCalculationResult,
  OperationType
>;

export interface PriceCalculationResponse {
  configurations: Record<InsuranceCoverage, PriceCalculationEntry>;
  composites?: Record<string, Composite>;
}

// Mapped from backend API response
export type PriceCalculationResult =
  | Partial<Record<InsuranceCoverage, PriceCalculationEntry>> & {
      composites?: Record<string, Composite>;
    };

export type Composites = Record<string, Composite>;

export interface Composite {
  id: string;
  type: string;
  coverageProduct: InsuranceCoverage;
  insurancePrices: { prices: CalculationPrice[] };
  prices: CalculationPrice[];
}

export interface CalculationPrice extends AkaHealthCalculationPrice {
  monthlyPrice: number;
  monthlyPricePrecise: number;
  yearlyPrice: number;
  yearlyPricePrecise: number;
  fullMonthlyPrice?: number;
  fullMonthlyPricePrecise?: number;
  fullYearlyPrice?: number;
  fullYearlyPricePrecise?: number;
  code?: string;
  value?: string;
}

export interface AkaHealthCalculationPrice {
  memberMonthlyPrice?: number;
  memberMonthlyPricePrecise?: number;
  memberYearlyPrice?: number;
  memberYearlyPricePrecise?: number;
  coInsuredMonthlyPrice?: number;
  coInsuredMonthlyPricePrecise?: number;
  coInsuredYearlyPrice?: number;
  coInsuredYearlyPricePrecise?: number;
}

export interface PriceCalculationEntry {
  prices: CalculationPrice[];
  compositions: string[];
  notAvailableReasons?: string[];
  selectedByDefault: boolean;
  tfaAmount?: {
    monthly: number;
    yearly: number;
  };
}

export enum OperationType {
  SEND_GET_PRODUCT_REQUEST = "SEND_GET_PRODUCT_REQUEST",
  SEND_PRICE_CALCULATION_REQUEST = "SEND_PRICE_CALCULATION_REQUEST",
  EDIT_PRICE_CALCULATION_FORM = "EDIT_PRICE_CALCULATION_FORM",
  SEND_GET_ADVICE_CART_REQUEST = "SEND_GET_ADVICE_CART_REQUEST",
}

export type OldPriceCalculationRequestParams = {
  productPriceUrl: string;
  priceCalculationRequest: PriceCalculationRequest;
  clearOldPriceCalculations?: boolean;
  stepForwardOnSuccess?: boolean;
  compositePrefix?: string;
};

export type NewPriceRequestCalculationParams = {
  requestInfo: InsuranceProductPriceRequestInfo;
  productPriceUrl: string;
  clearOldPriceCalculations?: boolean;
  agreement?: number;
  stepForwardOnSuccess?: boolean;
  compositePrefix?: string;
  numberOfProductsInCart: number;
};

export type PriceCalculationRequestParams =
  | OldPriceCalculationRequestParams
  | NewPriceRequestCalculationParams;

export interface PriceCalculationRequest {
  numberOfProductsInCart: number;
  productInfo?: InsuranceProductPriceRequestInfo;
  discountInfo?: DiscountInfo;
}

export interface DiscountInfo {
  agreementProduct: number;
  isNewInsuranceCustomer: boolean;
  paymentPeriod: string;
}

export interface GetProductRequestParams {
  type: INSURANCE_NAME_VALUE;
  cartId: string;
  productId: string;
}

export interface StoredAdviceCartStartPayload {
  cartId: string;
  isCollectiveAdvice: boolean;
}
